// |External compoents
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { SlidesModule } from 'ng2-slides';
import { NgxCarouselModule } from 'ngx-carousel';
import { TabModule } from 'angular-tabs-component';
import { BootstrapGrowlComponent, BootstrapGrowlService, BootstrapGrowlModule} from 'ngx-bootstrap-growl';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// |Normal components
import { AppComponent } from './app.component';
import { AppRouting } from './app-routing.module';
import { LoginComponent } from './components/login/login.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HomeComponent } from './components/home/home.component';
// |Modal components
import { ChangePasswordComponent } from './components/MODAL-change-password/change-password.component';
import { ConfirmModalComponent } from './components/MODAL-confirmModal/confirmModal.component';
import { SelectProfileComponent } from './components/MODAL-select-profile/select-profile.component';
import { PlswaitComponent } from './components/MODAL-plswait/plswait.component';
// |Services
import { AccountService } from './service/accountService.service';
import { InternalFunctionsRedirectService } from './service/internalFunctionsRedirectService.service';
import { Locale } from './service/locale.service';
// |Managers
import { DateTimeManager } from './manager/datetime.manager';
import { GrowlManager } from './manager/growl.manager';
import { ValidatorManager } from './manager/validator.manager';
import { DownloadManager } from './manager/download.manager';
import { SpoHttpInterceptor } from './manager/http.interceptor';
import { ModelsManager } from './manager/models.manager';
// |Extra imports
import 'hammerjs';
import { MaterialListComponent } from './components/material-list/material-list.component';
// import { BomExplosionComponent } from './components/bom-explosion/bom-explosion.component';
import { OrderComponent } from './components/order/order.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { ModalDeliveryPrintComponent } from './components/MODAL-delivery-print/modal-delivery-print.component';
import { StockComponent } from './components/stock/stock.component';
import { LotComponent } from './components/lot/lot.component';
import { ModalLotCharactsComponent } from './components/MODAL-lot-characts/modal-lot-characts.component';
import { SupplyDocComponent } from './components/supply-doc/supply-doc.component';
import { ModalMaterialDocComponent } from './components/modal-material-doc/modal-material-doc.component';
import { ModalBomExplosionComponent } from './components/modal-bom-explosion/modal-bom-explosion.component';

// |Ng module setup
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SidebarComponent,
    HomeComponent,
    ChangePasswordComponent,
    SelectProfileComponent,
    ConfirmModalComponent,
    PlswaitComponent,
    MaterialListComponent,
    // BomExplosionComponent,
    OrderComponent,
    DeliveryComponent,
    ModalDeliveryPrintComponent,
    StockComponent,
    LotComponent,
    ModalLotCharactsComponent,
    SupplyDocComponent,
    ModalMaterialDocComponent,
    ModalBomExplosionComponent
  ],
  imports: [
      BrowserModule,
      NgxCarouselModule,
      BrowserAnimationsModule,
      HttpModule,
      NgbModule.forRoot(),
      Ng2OrderModule,
      Ng2FilterPipeModule,
      MatTooltipModule,
      MatCardModule,
      SlidesModule,
      Ng2OrderModule,
//      ToolTipModule,
      TabModule,
      BootstrapGrowlModule,
      HttpClientModule
  ],
  providers: [
            AccountService,
            InternalFunctionsRedirectService,
            BootstrapGrowlService,
            GrowlManager,
            DateTimeManager,
            DownloadManager,
            ValidatorManager,
            Locale,
            ModelsManager,
            {
              provide: HTTP_INTERCEPTORS,
              useClass: SpoHttpInterceptor,
              multi: true
            }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts